module.exports = __webpack_public_path__ + "img/sn.d2bec7ef.svg";